
import { setUserProperties, logEvent, setUserId } from "firebase/analytics";
import { shouldTrackDemoFeedAnalytics } from "../player/Utils";

class AnalyticsManager {

    constructor(analytics) {
        this.analytics = analytics;
    }

    log(eventName, bundle = {}) {
        logEvent(this.analytics, eventName, bundle || {});
    }

    skipDemoFeedAnalytics() {
        return !shouldTrackDemoFeedAnalytics();
    }

    setUserId(uid){
        setUserId(this.analytics, uid);
    }

    setUserProperty(testedGroup, premium){    
        if (window.location.pathname.includes("/p/")){
            setUserProperties(this.analytics, {app_type: "web_player", tested_group: testedGroup, premium: premium });
        }
        else {
            setUserProperties(this.analytics, {app_type: "web_maker", tested_group: testedGroup, premium: premium }); 
        }
    }  
        
    logHomePageScreenViewTag() {
        let bundle = {
            screen_name: "home_page",
            screen_class: "ProductPage",
        };

        this.log('screen_view', bundle);
    }

    logClickLogoTag(){
        let bundle = {
            
        };

        this.log('click_logo', bundle);
    }

    logClickHomePageWSTag(){
        let bundle = {
            
        };

        this.log('click_home_page_ws', bundle);
    }

    logHomePageAdScreenViewTag() {
        let bundle = {
            screen_name: "home_page_ad",
            screen_class: "InstantAdHP",
        };

        this.log('screen_view', bundle);
    }
    
    logClickHomePageAdTag(){
        let bundle = {
            
        };

        this.log('click_home_page_ad', bundle);
    }

    logClickHomePageFoodAgenciesTag(){
        let bundle = {
            
        };

        this.log('click_home_page_food_agencies', bundle);
    }
    
    logPricingScreenViewTag() {
        let bundle = {
            screen_name: "pricing",
            screen_class: "Pricing",
        };

        this.log('screen_view', bundle);
    }
    
    logClickStartFreeInPricingTag() {
        let bundle = {            
        };
        
        this.log('start_free_in_pricing', bundle);
    }
        
    logClickTryPremiumInPricingTag() {
        let bundle = {            
        };
        
        this.log('try_premium_in_pricing', bundle);
    }
            
    logClickChoosePremiumInPricingTag() {
        let bundle = {            
        };
        
        this.log('choose_premium_in_pricing', bundle);
    }
        
    logClickPricingTag(){
        let bundle = {
            
        };

        this.log('click_pricing', bundle);
    }

    logClickInWebDemoTag(){
        let bundle = {
            
        };

        this.log('click_web_demo', bundle);
    }

    logScrollInWebDemoTag(){
        let bundle = {

        };

        this.log('scroll_web_demo', bundle);
    }

    logDemoFeedScreenViewTag(origin) {
        if (this.skipDemoFeedAnalytics()) return;
        let bundle = {
            screen_name: "demo_feed",
            screen_class: "DemoFeed",
        };

        if (origin) {
            bundle.origin = origin;
        }

        this.log('screen_view', bundle);
    }

    logDemoFeedScrapTag(origin, positive) {
        if (this.skipDemoFeedAnalytics()) return;
        let bundle = {
            positive_action_over_negative: positive,
        };

        if (origin) {
            bundle.origin = origin;
        }

        this.log('demo_feed_scrap', bundle);
    }

    logDemoFeedLearnMoreTag(origin) {
        if (this.skipDemoFeedAnalytics()) return;
        let bundle = {};

        if (origin) {
            bundle.origin = origin;
        }

        this.log('click_demo_feed_learn_more', bundle);
    }

    logDemoFeedViewFullscreenTag(origin) {
        if (this.skipDemoFeedAnalytics()) return;
        let bundle = {};

        if (origin) {
            bundle.origin = origin;
        }

        this.log('click_demo_feed_view_fullscreen', bundle);
    }

    logClickDemoFeedCtaLeftTag(type, origin) {
        if (this.skipDemoFeedAnalytics()) return;
        let bundle = {
            type: type,
        };

        if (origin) {
            bundle.origin = origin;
        }

        this.log('click_demo_feed_cta_left', bundle);
    }

    logClickDemoFeedCtaRightTag(type, origin) {
        if (this.skipDemoFeedAnalytics()) return;
        let bundle = {
            type: type,
        };

        if (origin) {
            bundle.origin = origin;
        }

        this.log('click_demo_feed_cta_right', bundle);
    }

    /** Screenshot CTA DemoFeed (site web / Instagram / Google) — type: website|instagram|google */
    logClickDemoFeedCtaShotTag(type, origin) {
        if (this.skipDemoFeedAnalytics()) return;
        let bundle = {
            type: type,
        };

        if (origin) {
            bundle.origin = origin;
        }

        this.log('click_demo_feed_cta_shot', bundle);
    }

    logHPTryMakerTag(origin) {
        let bundle = {
            origin: origin,
        };
        
        this.log('try_maker', bundle);
    }

    logHPVideoTag(origin, playOverEnded) {
        let bundle = {
            origin: origin,
            positive_action_over_negative: playOverEnded,
        };

        this.log('hp_video', bundle);
    }

    logHPCreate1Clic(popupOrigin){
        const topOrigins = new Set(["create1Click"]);
        const createStepsOrigins = new Set(["create1Click_hp_benefit21"]);
        let origin = "home_page_bottom";
        if (topOrigins.has(popupOrigin)) {
            origin = "home_page_top";
        } else if (createStepsOrigins.has(popupOrigin)) {
            origin = "home_page_create_steps";
        }

        let bundle = { origin };

        this.log('create_1_clic', bundle);
    }

    logHPRequestDemoTag(origin) {
        if (origin === "demo_feed" && this.skipDemoFeedAnalytics()) return;
        const topOrigins = new Set([
            "scheduleDemo",
            "ad_scheduleDemo",
        ]);
        const passthroughOrigins = new Set([
            "demo_feed",
        ]);
        let mappedOrigin = origin;
        if (topOrigins.has(origin)) {
            mappedOrigin = "home_page_top";
        } else if (!passthroughOrigins.has(origin)) {
            mappedOrigin = "home_page_bottom";
        }
        const bundle = {
            origin: mappedOrigin,
        };

        this.log("request_demo", bundle);
    }

    logMakerdCreate1Clic(){
        let bundle = {
            origin: "maker",
        };

        this.log('create_1_clic', bundle);
    }

    logLoginTag(method) {
        let bundle = {
            method: method,
        };

        this.log('login', bundle);
    }
    
    logSendEmailLinkTag() {
        let bundle = {
            
        };

        this.log('send_email_link', bundle);
    }

    logCancelLoginTag(method) {
        let bundle = {
            method: method,
        };

        this.log('cancel_login', bundle);
    }

    logAcceptTermsTag(acceptOverCancel) {
        let bundle = {
            positive_action_over_negative: acceptOverCancel
        };

        this.log('accept_terms', bundle);
    }

    /**
     * maker without login to login
     */
    logLoginFromAnonymousTag(uid, anonymousUid) {
        let bundle = {
            uid: uid,
            anonymous_uid: anonymousUid,
        };

        this.log('login_from_anonymous', bundle);
    }

    /**
     * only from the product page to the maker without login and without previous login     
     */
    logFBIdToAnonymousTag(firebaseId, anonymousUid) {
        let bundle = {
            firebase_installation_id: firebaseId,
            anonymous_uid: anonymousUid
        };

        this.log('fbid_to_anonymous', bundle);
    }

    /**
     * only from the product page, without previous login
     */
    logFBIdToLoggedTag(firebaseId, uid) {
        let bundle = {
            firebase_installation_id: firebaseId,
            uid: uid
        };

        this.log('fbid_to_uid', bundle);
    }

    logChoosePageTag(storyId) {
        let bundle = {    
            item_id: storyId        
        };

        this.log('choose_page', bundle);
    }

    logReadFAQTag(origin, faqId){
        let bundle = {
            origin: origin,
            faq_id: faqId,
        };
        
        this.log('read_faq', bundle);
    }

    logReadCGUTag(origin){
        let bundle = {
            origin: origin
        };
        
        this.log('read_cgu', bundle); 
    }

    logReadCGVTag(origin){
        let bundle = {
            origin: origin
        };
        
        this.log('read_cgv', bundle); 
    }
    
    logReadPrivacyTag(){
        let bundle = {
            origin: origin
        };
        
        this.log('read_terms', bundle); 
    }   
    
    /**
     * before the restaurant is chosen
     */
    logMakerScreenViewTag() {
        let bundle = {
            screen_name: "maker",
            screen_class: "maker",
        };

        this.log('screen_view', bundle);
    }    

    /**
     * after the restaurant is chosen
     */
    logChooseRestaurantScreenViewTag(storyId) {
        let bundle = {
            screen_name: "choose_restaurant",
            screen_class: "choose_restaurant",
            item_id: storyId
        };

        this.log('screen_view', bundle);
    }
    
    logChooseRestaurantTag(storyId, city, country, reservable, posId){
        let bundle = {
            item_id: storyId,
            city: city,
            country: country,
            reservable: reservable,
            pos_id: posId,
        };
        
        this.log('choose_restaurant', bundle); 
    }

    logChooseBusinessTypeTag(storyId, businessType, addOverRemove){
        let bundle = {
            item_id: storyId,
            business_type: businessType,
            positive_action_over_negative: addOverRemove,
        };
        
        this.log('choose_business_type', bundle); 
    }

    logChooseNeighborhoodTag(storyId, neighborhood, addOverRemove){
        let bundle = {
            item_id: storyId,
            neighborhood: neighborhood,
            positive_action_over_negative: addOverRemove,
        };
        
        this.log('choose_neighborhood', bundle); 
    }

    logChoosePhoneNumberTag(storyId, origin, addOverRemove){
        let bundle = {
            item_id: storyId,
            origin: origin,
            positive_action_over_negative: addOverRemove,
        };
        
        this.log('choose_phone_number', bundle); 
    }

    logSelectHoursOpeningTag(storyId){
        let bundle = {
            item_id: storyId,            
        };
        
        this.log('select_hours_opening', bundle); 
    }

    logSelectHoursHoursTag(storyId){
        let bundle = {
            item_id: storyId,            
        };
        
        this.log('select_hours_hours', bundle); 
    }

    logDeleteHoursPeriodTag(storyId){
        let bundle = {
            item_id: storyId,            
        };
        
        this.log('delete_hours_period', bundle); 
    }

    logAddHoursPeriodTag(storyId){
        let bundle = {
            item_id: storyId,            
        };
        
        this.log('add_hours_period', bundle); 
    }

    logSaveHoursTag(storyId){
        let bundle = {
            item_id: storyId,            
        };
        
        this.log('save_hours', bundle); 
    }  
    
    logAddReviewsTag(storyId){
        let bundle = {
            item_id: storyId,            
        };
        
        this.log('add_reviews', bundle); 
    }

    logTryPremiumTag(){
        let bundle = {
           
        };
        
        this.log('try_premium', bundle); 
    }

    logStayFreeTag(){
        let bundle = {
           
        };
        
        this.log('stay_free', bundle); 
    }
    
    logDowngradeFreeTag(){
        let bundle = {
           
        };
        
        this.log('downgrade_free', bundle); 
    }
        
    logStayPremiumTag(){
        let bundle = {
           
        };
        
        this.log('stay_premium', bundle); 
    }
        
    logUpgradePremiumTag(){
        let bundle = {
           
        };
        
        this.log('upgrade_premium', bundle); 
    }
        
    logDowngradePremiumTag(){
        let bundle = {
           
        };
        
        this.log('downgrade_premium', bundle); 
    }

    logStayPlusTag(){
        let bundle = {
           
        };
        
        this.log('stay_plus', bundle); 
    }
        
    logUpgradePlusTag(){
        let bundle = {
           
        };
        
        this.log('upgrade_plus', bundle); 
    }
        
    logUpgradePremiumPlusTag(){
        let bundle = {
           
        };
        
        this.log('upgrade_premium_plus', bundle); 
    }
            
    logOpenCustomerPortalTag(){
        let bundle = {
           
        };
        
        this.log('open_customer_portal', bundle); 
    }

    logOpenPopupTag(storyId, popupName, openOverClose, playMode = null){
        if (popupName === "demo_feed_scrap" && this.skipDemoFeedAnalytics()) return;
        let bundle = {
            item_id: storyId,
            positive_action_over_negative: openOverClose,
            popup_name: popupName,
        };

        if (playMode){
            bundle.play_mode = playMode;
        }
        
        this.log('open_popup', bundle); 
    }

    logChainRestaurantSearchCityTag(storyId, success){
        let bundle = {
            item_id: storyId,
            positive_action_over_negative: success,
        };

        this.log('chain_restaurant_search_city', bundle);
    }

    logChainRestaurantSearchGeolocationTag(storyId, success){
        let bundle = {
            item_id: storyId,
            positive_action_over_negative: success,
        };

        this.log('chain_restaurant_search_geolocation', bundle);
    }

    logChainRestaurantResetSearchTag(storyId){
        let bundle = {
            item_id: storyId,
        };

        this.log('chain_restaurant_reset_search', bundle);
    }

    logChainRestaurantMarkerTag(storyId){
        let bundle = {
            item_id: storyId,
        };

        this.log('chain_restaurant_marker', bundle);
    }

    logChainRestaurantChooseListTag(storyId){
        let bundle = {
            item_id: storyId,
        };

        this.log('chain_restaurant_choose_list', bundle);
    }

    logChainRestaurantChooseMapTag(storyId){
        let bundle = {
            item_id: storyId,
        };

        this.log('chain_restaurant_choose_map', bundle);
    }

    logOpenTabTag(storyId, tabName){
        let bundle = {
            item_id: storyId,
            tab_name: tabName,
        };
        
        this.log('open_tab', bundle); 
    }

    logOpenAccountMenuTag(storyId, accountOption){
        let bundle = {
            item_id: storyId,
            account_option: accountOption,
        };
        
        this.log('open_account_option', bundle); 
    }   
    
    logCloseAccountMenuTag(){
        let bundle = {

        };
        
        this.log('close_account_option', bundle); 
    }

    logAuthorizePhoneNumberTag(storyId, authorizeOverNot){
        let bundle = {
            item_id: storyId,
            positive_action_over_negative: authorizeOverNot,
        };
        
        this.log('authorize_phone_number', bundle); 
    }

    logReplaceGBookingByWebLinkTag(storyId){
        let bundle = {
            item_id: storyId,
        };

        this.log('replace_g_booking_by_web_link', bundle);
    }
    
    logReplaceWebLinkByGBookingTag(storyId){
        let bundle = {
            item_id: storyId,
        };

        this.log('replace_web_link_by_g_booking', bundle);
    }

    logChooseBookingLinkTag(storyId, addOverRemove){
        let bundle = {
            item_id: storyId,
            positive_action_over_negative: addOverRemove,
        };
        
        this.log('choose_booking_link', bundle); 
    }
    
    logAddOrderingPlatformTag(storyId, addOverRemove){
        let bundle = {
            item_id: storyId,
            positive_action_over_negative: addOverRemove,
        };
        
        this.log('add_ordering_platform', bundle); 
    }

    logRestartStoryTag(storyId, restartOverCancel){
        let bundle = {
            item_id: storyId,
            positive_action_over_negative: restartOverCancel,
        };
        
        this.log('restart_story', bundle); 
    }       

    logConnectInstagramTag(storyId, addOverRemove){
        let bundle = {
            item_id: storyId,
            positive_action_over_negative: addOverRemove,
        };
        
        this.log('connect_instagram', bundle); 
    }

    logChooseMyLogoTag(storyId, from, type, addOverRemove){
        let bundle = {
            item_id: storyId,
            content_source: from,
            content_type: type,
            positive_action_over_negative: addOverRemove,
        };
        
        this.log('choose_logo', bundle); 
    }

    logChoosePrimaryColorTag(storyId, from){
        let bundle = {
            item_id: storyId,
            content_source: from,            
        };
        
        this.log('choose_primary_color', bundle); 
    }

    logChooseSecondaryColorTag(storyId, from){
        let bundle = {
            item_id: storyId,
            content_source: from,            
        };
        
        this.log('choose_secondary_color', bundle); 
    }

    logChooseMyMusicTag(storyId, from, type, addOverRemove){
        let bundle = {
            item_id: storyId,
            content_source: from,
            content_type: type,
            positive_action_over_negative: addOverRemove,
        };
        
        this.log('choose_music', bundle); 
    }

    logSetVolumeMusicTag(storyId, playMode, onOverOff){
        let bundle = {
            item_id: storyId,
            play_mode: playMode,
            positive_action_over_negative: onOverOff,
        };
        
        this.log('set_volume_music', bundle); 
    }

    logChooseTaglineTag(storyId, addOverRemove){
        let bundle = {
            item_id: storyId,
            positive_action_over_negative: addOverRemove,
        };            
        
        this.log('choose_tagline', bundle); 
    }
    
    logChooseRestaurantNameTag(storyId, addOverRemove){
        let bundle = {
            item_id: storyId,
            positive_action_over_negative: addOverRemove,
        };            
        
        this.log('choose_restaurant_name', bundle); 
    }
            
    logChooseStickersScreenViewTag(storyId) {
        let bundle = {
            screen_name: "choose_stickers",
            screen_class: "choose_stickers",
            item_id: storyId
        };

        this.log('screen_view', bundle);
    }

    logChooseStoreFrontTag(storyId, source, type, addOverRemove) {
        let bundle = {
            item_id: storyId,
            content_source: source,
            content_type: type,
            positive_action_over_negative: addOverRemove,
        };

        this.log('choose_store_front', bundle);
    }    

    logChooseInsideTag(storyId, source, type, addOverRemove) {
        let bundle = {
            item_id: storyId,
            content_source: source,
            content_type: type,
            positive_action_over_negative: addOverRemove,
        };

        this.log('choose_inside', bundle);
    }
    
    logChooseMenuTag(storyId, source, type, addOverRemove) {
        let bundle = {
            item_id: storyId,
            content_source: source,
            content_type: type,
            positive_action_over_negative: addOverRemove,
        };

        this.log('choose_menu', bundle);
    }

    logNextPageTag(storyId, origin) {
        let bundle = {
            item_id: storyId,
            origin: origin
        };

        this.log('next_page', bundle);
    }

    logPreviousPageTag(storyId, origin) {
        let bundle = {
            item_id: storyId,
            origin: origin
        };

        this.log('previous_page', bundle);
    }

    logClickWeTransferTag(storyId, origin){
        let bundle = {
            item_id: storyId,
            origin: origin,
        };

        this.log('click_we_transfer', bundle);

    }

    logChooseStyleTag(storyId, type) {
        let bundle = {
            item_id: storyId,
            type: type,
        };

        this.log('choose_style', bundle);
    }

    logDragNDropTag(storyId, origin) {
        let bundle = {
            item_id: storyId,
            origin: origin
        };

        this.log('drag_drop', bundle);
    }
                
    logChooseActionsScreenViewTag(storyId) {
        let bundle = {
            screen_name: "choose_actions",
            screen_class: "choose_actions",
            item_id: storyId
        };

        this.log('screen_view', bundle);
    }

    logChooseFullMenuTag(storyId, source, type, addOverRemove) {
        let bundle = {
            item_id: storyId,
            content_source: source,
            content_type: type,
            positive_action_over_negative: addOverRemove,
        };

        this.log('choose_full_menu', bundle);
    }

    logChooseFullMenuEnTag(storyId, source, type, addOverRemove) {
        let bundle = {
            item_id: storyId,
            content_source: source,
            content_type: type,
            positive_action_over_negative: addOverRemove,
        };

        this.log('choose_full_menu_en', bundle);
    }

    logChooseDayMenuTag(storyId, source, type, addOverRemove) {
        let bundle = {
            item_id: storyId,
            content_source: source,
            content_type: type,
            positive_action_over_negative: addOverRemove,
        };

        this.log('choose_day_menu', bundle);
    }
    
    logDeleteStoryTag(storyId, deleteOverCancel) {
        let bundle = {
            item_id: storyId,
            positive_action_over_negative: deleteOverCancel
        };

        this.log('delete_story', bundle);
    }

    logDuplicateStoryTag(storyId, duplicateOverCancel) {
        let bundle = {
            item_id: storyId,
            positive_action_over_negative: duplicateOverCancel
        };

        this.log('duplicate_story', bundle);
    }

    logAbandonChangesTag(storyId, abandonOverCancel, origin) {
        let bundle = {
            item_id: storyId,
            positive_action_over_negative: abandonOverCancel,
            origin: origin
        };

        this.log('abandon_changes', bundle);
    }
    
    logResetStoryTag(storyId, resetOverCancel, origin) {
        let bundle = {
            item_id: storyId,
            positive_action_over_negative: resetOverCancel,
            origin: origin
        };

        this.log('reset_story', bundle);
    }

    logPreviewStoryTag(storyId, openOverClose, origin) {
        let bundle = {
            item_id: storyId,
            positive_action_over_negative: openOverClose,
            origin: origin
        };

        this.log('preview_story', bundle);
    }

    logCheckAccountMenuTag() {
        let bundle = {
            
        };

        this.log('check_account_menu', bundle);
    }
    
    logLogoutTag(logoutOverCancel) {
        let bundle = {
            positive_action_over_negative: logoutOverCancel
        };

        this.log('logout', bundle);
    }

    logOptimizeMenuTag(storyId) {
        let bundle = {
            item_id: storyId,
        };

        this.log('optimize_menu', bundle);
    }
    
    logChooseMenuTypeTag(storyId, type) {
        let bundle = {
            item_id: storyId,    
            type: type,       
        };

        this.log('choose_menu_type', bundle);
    }

    logPublishTag(storyId) {
        let bundle = {
            item_id: storyId
        };

        this.log('publish_story', bundle);
    }  
    
    logReturnStoriesTag(storyId) {
        let bundle = {
            item_id: storyId
        };

        this.log('return_stories', bundle);
    } 
                
    logUseItScreenViewTag(storyId) {
        let bundle = {
            screen_name: "use_it",
            screen_class: "use_it",
            item_id: storyId
        };

        this.log('screen_view', bundle);
    }
        
    logChangeLinkTag(storyId, changeOverCancel) {
        let bundle = {
            item_id: storyId,
            positive_action_over_negative: changeOverCancel
        };

        this.log('change_link', bundle);
    }

    logConfigurePixelsTag(storyId, changeOverCancel) {
        let bundle = {
            item_id: storyId,
            positive_action_over_negative: changeOverCancel
        };

        this.log('configure_pixels', bundle);
    }

    logConfigureInfluencerTag(storyId, changeOverCancel) {
        let bundle = {
            item_id: storyId,
            positive_action_over_negative: changeOverCancel
        };
        
        this.log('configure_influencer', bundle);
    }

    logConfigureNearTag(storyId, changeOverCancel) {
        let bundle = {
            item_id: storyId,
            positive_action_over_negative: changeOverCancel
        };
        
        this.log('configure_near', bundle);
    }
    
    logConfigurePromoTag(storyId, changeOverCancel) {
        let bundle = {
            item_id: storyId,
            positive_action_over_negative: changeOverCancel
        };
        
        this.log('configure_promo', bundle);
    }
    
    logListStoriesTag(storyId, origin) {
        let bundle = {
            item_id: storyId,
            origin: origin
        };

        this.log('list_stories', bundle);
    }

    logListStoriesScreenViewTag() {
        let bundle = {
            screen_name: "list_stories",
            screen_class: "list_stories"
        };

        this.log('screen_view', bundle);
    }

    logPreferencesScreenViewTag() {
        let bundle = {
            screen_name: "preferences",
            screen_class: "preferences"
        };

        this.log('screen_view', bundle);
    }

    logClickHelpTag() {
        let bundle = {

        };

        this.log('click_help', bundle);
    }

    logBackToPreferencesFromHelpTag() {
        let bundle = {
            
        };

        this.log('back_help_to_preferences', bundle);
    }

    logHelpScreenViewTag() {
        let bundle = {
            screen_name: "help",
            screen_class: "help"
        };

        this.log('screen_view', bundle);
    }

    logReadLegalsTag() {
        let bundle = {
            
        };

        this.log('read_legals', bundle);
    }
    
    logBackToPreferencesFromLegalsTag() {
        let bundle = {
            
        };

        this.log('back_legals_to_preferences', bundle);
    }

    logLegalsScreenViewTag() {
        let bundle = {
            screen_name: "legals",
            screen_class: "legals"
        };

        this.log('screen_view', bundle);
    }

    logAssociateToFacebookTag() {

        this.log('associate_to_facebook');
    }

    logTransferTag(transferOverCancel) {
        let bundle = {
            positive_action_over_negative: transferOverCancel
        };

        this.log('transfer', bundle);
    }

    logAcceptTransferTag(storyId) {
        let bundle = {
            item_id: storyId
        };

        this.log('accept_transfer', bundle);
    }

    logDeleteAccountTag() {
        let bundle = {
           
        };

        this.log('delete_account', bundle);
    }

    logCreateStoryTag() {
        let bundle = {
            
        };

        this.log('create_story', bundle);
    }

    logClickStatDetailTag(storyId) {
        let bundle = {  
            item_id: storyId
        };

        this.log('click_stat_detail', bundle);
    }

    logCreateStoryTag() {
        let bundle = {  

        };

        this.log('create_story', bundle);
    }

    logViewStatDetailTag(storyId) {
        let bundle = {
            item_id: storyId
        };

        this.log('view_stat_detail', bundle);
    }

    logStatDetailScreenViewTag(storyId) {
        let bundle = {
            screen_name: "stat_detail",
            screen_class: "Stats",
            item_id: storyId
        };

        this.log('screen_view', bundle);
    }

    logCloseDetailScreenViewTag(storyId) {
        let bundle = {
            item_id: storyId
        };

        this.log('close_detail_stat', bundle);
    }

    logModifyStoryScreenViewTag(storyId, downsizeRunning = false) {
        let bundle = {
            item_id: storyId
        };
        if (downsizeRunning){
            bundle.downsize_running = downsizeRunning;
        }

        this.log('modify_story', bundle);
    }
    
    logLaunchStoryScreenViewTag(storyId) {
        let bundle = {
            item_id: storyId
        };

        this.log('launch_story', bundle);
    }
        
    logCopyLinkTag(storyId, origin) {
        let bundle = {
            item_id: storyId,
            origin: origin,
        };

        this.log('copy_link', bundle);
    }

    logPlayStoryScreenViewTag(storyId, playMode, origin){        
        let bundle = {
            item_id: storyId,
            screen_name: "story",
            play_mode: playMode,
            screen_class: "Player",
        };
        if (origin) {
            bundle.origin = origin;
        }
        
        this.log('screen_view', bundle);        
    }    
            
    logShareTag(storyId, playMode) {
        let bundle = {
            item_id: storyId,
            play_mode: playMode,
        };

        this.log('share', bundle);
    }
                
    logBookTag(storyId, playMode, type) {
        let bundle = {
            item_id: storyId,
            play_mode: playMode,
            type: type
        };

        this.log('book', bundle);
    }
                
    logContactTag(storyId, playMode, type) {
        let bundle = {
            item_id: storyId,
            play_mode: playMode,
            type: type
        };

        this.log('contact', bundle);
    }
                    
    logCheckHoursTag(storyId, playMode, openOverClose) {
        let bundle = {
            item_id: storyId,
            play_mode: playMode,
            positive_action_over_negative: openOverClose
        };

        this.log('check_hours', bundle);
    }
                       
    logCheckChatTag(storyId, playMode, openOverClose) {
        let bundle = {
            item_id: storyId,
            play_mode: playMode,
            positive_action_over_negative: openOverClose
        };

        this.log('check_chat', bundle);
    }

    logCheckPromoTag(storyId, playMode, openOverClose) {
        let bundle = {
            item_id: storyId,
            play_mode: playMode,
            positive_action_over_negative: openOverClose
        };
        
        this.log('check_promo', bundle);
    }

    logAskChatTag(storyId, playMode, openOverClose) {
        let bundle = {
            item_id: storyId,
            play_mode: playMode
        };

        this.log('ask_chat', bundle);
    }

    logCheckGMapsFromChatTag(storyId, playMode) {
        let bundle = {
            item_id: storyId,
            play_mode: playMode
        };

        this.log('check_gmaps_from_chat', bundle);
    }
    
    logCheckWebsiteFromChatTag(storyId, playMode) {
        let bundle = {
            item_id: storyId,
            play_mode: playMode
        };
        
        this.log('check_website_from_chat', bundle);
    }
    
    logCheckInfluencerTag(storyId, playMode, openOverClose) {
        let bundle = {
            item_id: storyId,
            play_mode: playMode,
            positive_action_over_negative: openOverClose
        };

        this.log('check_influencer', bundle);
    }
                    
    logCheckReviewsTag(storyId, playMode, openOverClose) {
        let bundle = {
            item_id: storyId,
            play_mode: playMode,
            positive_action_over_negative: openOverClose
        };

        this.log('check_reviews', bundle);
    }
                        
    logCheckItineraryTag(storyId, playMode) {
        let bundle = {
            item_id: storyId,
            play_mode: playMode,
        };

        this.log('check_itinerary', bundle);
    }
                            
    logOpenInsideTag(storyId, playMode, openOverClose) {
        let bundle = {
            item_id: storyId,
            play_mode: playMode,
            positive_action_over_negative: openOverClose
        };

        this.log('open_inside', bundle);
    }
                                
    logSwipeInsideTag(storyId, playMode) {
        let bundle = {
            item_id: storyId,
            play_mode: playMode,
        };

        this.log('swipe_inside', bundle);
    }
                                
    logOpenMenuTag(storyId, playMode, openOverClose) {
        let bundle = {
            item_id: storyId,
            play_mode: playMode,
            positive_action_over_negative: openOverClose
        };

        this.log('open_menu', bundle);
    }
                                
    logSwipeMenuTag(storyId, playMode) {
        let bundle = {
            item_id: storyId,
            play_mode: playMode,
        };

        this.log('swipe_menu', bundle);
    }

    logOpenFullMenuTag(storyId, playMode, type, openOverClose) {
        let bundle = {
            item_id: storyId,
            play_mode: playMode,
            type: type,
            positive_action_over_negative: openOverClose
        };

        this.log('open_full_menu', bundle);
    }

    logOpenDishDetalTag(storyId, playMode, openOverClose) {
        let bundle = {
            item_id: storyId,
            play_mode: playMode,
            positive_action_over_negative: openOverClose
        };

        this.log('open_dish_detail', bundle);
    }
                                    
    logSwipeFullMenuTag(storyId, playMode) {
        let bundle = {
            item_id: storyId,
            play_mode: playMode,
        };

        this.log('swipe_full_menu', bundle);
    }

    logProfileOptimizationToolScreenViewTag() {
        let bundle = {
            screen_name: "profile_optimization_tool",
            screen_class: "RestaurantTools",
        };

        this.log('screen_view', bundle);
    }

    logProfileOptimizationPlaceSelectedTag(placeId) {
        let bundle = {
            pos_id: placeId,
        };

        this.log('profile_optimization_place_selected', bundle);
    }

    logProfileOptimizationAuditStartTag(placeId) {
        let bundle = {
            pos_id: placeId,
        };

        this.log('profile_optimization_audit_start', bundle);
    }

    logProfileOptimizationAuditResultTag(placeId) {
        let bundle = {
            pos_id: placeId,
        };

        this.log('profile_optimization_audit_result', bundle);
    }

    logOpinionToolScreenViewTag() {
        let bundle = {
            screen_name: "opinion_tool",
            screen_class: "RestaurantTools",
        };

        this.log('screen_view', bundle);
    }

    logOpinionPlaceSelectedTag(placeId) {
        let bundle = {
            pos_id: placeId,
        };

        this.log('opinion_place_selected', bundle);
    }

    logOpinionRunStartTag(placeId) {
        let bundle = {
            pos_id: placeId,
        };

        this.log('opinion_run_start', bundle);
    }

    logOpinionRunResultTag(placeId) {
        let bundle = {
            pos_id: placeId,
        };

        this.log('opinion_run_result', bundle);
    }

    logServiceMagnetToolScreenViewTag() {
        let bundle = {
            screen_name: "service_magnet_tool",
            screen_class: "RestaurantTools",
        };

        this.log('screen_view', bundle);
    }

    logServiceMagnetPlaceSelectedTag(placeId) {
        let bundle = {
            pos_id: placeId,
        };

        this.log('service_magnet_place_selected', bundle);
    }

    logServiceMagnetRunStartTag(placeId) {
        let bundle = {
            pos_id: placeId,
        };

        this.log('service_magnet_run_start', bundle);
    }

    logServiceMagnetRunResultTag(placeId) {
        let bundle = {
            pos_id: placeId,
        };

        this.log('service_magnet_run_result', bundle);
    }

    logOccasionMagnetToolScreenViewTag() {
        let bundle = {
            screen_name: "occasion_magnet_tool",
            screen_class: "RestaurantTools",
        };

        this.log('screen_view', bundle);
    }

    logOccasionMagnetPlaceSelectedTag(placeId) {
        let bundle = {
            pos_id: placeId,
        };

        this.log('occasion_magnet_place_selected', bundle);
    }

    logOccasionMagnetRunStartTag(placeId) {
        let bundle = {
            pos_id: placeId,
        };

        this.log('occasion_magnet_run_start', bundle);
    }

    logOccasionMagnetRunResultTag(placeId) {
        let bundle = {
            pos_id: placeId,
        };

        this.log('occasion_magnet_run_result', bundle);
    }

    logPixelConsentTag(storyId, playMode, type, positiveActionOverNegative) {
        const bundle = {
            item_id: storyId,
            play_mode: playMode,
            type: type,
            positive_action_over_negative: positiveActionOverNegative,
        };

        this.log('pixel_consent', bundle);
    }

}

export default AnalyticsManager;
